import React from 'react';
import { GlobalState, UI } from '@leverege/ui-redux';
import { UserRoles, ItemDelegate, Relationship } from '@leverege/molten-core';
import { Config } from '@leverege/plugin';
import { ResourceTemporaryUsersScreen } from '@leverege/api-ui-user-management';
import { Attributes } from '@leverege/ui-attributes';
import TemporaryUserManagementScreen from "../../screens/temporaryUserManagement/LazyTemporaryUserManagementScreen.js";
import NoDataView from "../../dataViewers/views/NoDataView.js";
import { jsx as _jsx } from "react/jsx-runtime";
function create(molten, relationship, {
  actionPath,
  t,
  tIcon
}) {
  // Get parameters
  const {
    blueprint,
    path
  } = relationship;
  return {
    id: `route.${path}.ResourceTemporaryUsers`,
    exact: true,
    path: actionPath,
    matches: {
      client: 'ItemScreen',
      path,
      objectType: blueprint.type
    },
    render: props => {
      const {
        match,
        location,
        history,
        ...rest
      } = props;
      const iRel = relationship.createItem(match);
      const allUserRoles = UI.get(GlobalState.get(), 'allUserRoles');

      // Create the role filter
      const roleFilter = UserRoles.createTempUserRoleFilter(allUserRoles, Relationship.getResourceIdHierarchy(relationship, match), blueprint);
      const delegate = new ItemDelegate({
        match,
        relationship: iRel,
        id: iRel.id
      });
      let noDataMessage;
      noDataMessage = Config.get(ResourceTemporaryUsersScreen.CLIENT, 'noDataMessage', NoDataView);
      if (noDataMessage != null && typeof noDataMessage !== 'string') {
        // assume its a component class/function
        const Clazz = noDataMessage;
        const noDataProps = {
          noDataTitleKey: 'noDataTemporaryUsersTitle',
          noDataBodyKey: 'noDataTemporaryUsersBody',
          noDataIconKey: 'noDataTemporaryUsers',
          tNoDataIconKey: 'noDataTemporaryUsers',
          noDataDocLinkKey: 'noDataTemporaryUsersDocLink',
          noSearchResultsTitleKey: 'noSearchResultsTemporaryUsersTitle',
          noSearchResultsBodyKey: 'noSearchResultsTemporaryUsersBody',
          noSearchResultsIconKey: 'noSearchResultsTemporaryUsers',
          tNoSearchResultsIconKey: 'noSearchResultsTemporaryUsers',
          defaultNoDataTitle: null
        };
        noDataMessage = /*#__PURE__*/_jsx(Clazz, {
          ...props,
          ...noDataProps,
          relationship: relationship,
          client: ResourceTemporaryUsersScreen.CLIENT,
          t: t,
          tIcon: tIcon
        });
      }
      const screenProps = {
        ...rest,
        match,
        location,
        history,
        relationship,
        title: t('title'),
        selectorProps: {
          simple: true,
          roleFilter
        },
        variants: {
          editorPane: 'formBody',
          inputLabel: 'inputTitle',
          inputText: 'default',
          inputCaption: 'caption',
          selectionSubtitle: 'caption',
          titleBar: 'screenTitle',
          toolbar: 'actionBar'
        },
        projectId: molten.getConfig('api/projectId'),
        resourceId: iRel.id,
        getResourceName: () => Attributes.get('name', iRel.objectType, delegate.getItem()),
        systemId: relationship?.systemId,
        delegate,
        actions: delegate,
        // TODO: Remove in future version
        emailOptions: molten.getConfig('userManagement/emailOptions'),
        smsOptions: molten.getConfig('userManagement/smsOptions'),
        uiName: molten.getConfig('uiName'),
        uiUrl: window.location.origin,
        calcUiName: true,
        noDataMessage
      };
      return /*#__PURE__*/React.createElement(TemporaryUserManagementScreen, screenProps);
    }
  };
}
export default {
  create
};